function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { memo, useContext, useMemo } from 'react';
import { useLogger } from '../../providers/LoggerProvider.js';
import { ErrorBoundary } from '../ErrorBoundary.js';
import { CMSContext } from './CMSProvider.js';
import { jsx } from 'react/jsx-runtime';
const renderNestedComponents = (content, onError, components = {}, options
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
) => {
  if (!content) return null;
  return content.map((contentEntry, index) => {
    const contentId = contentEntry?.sys?.contentType?.sys?.id;
    if (!contentId) return null;
    const Component = components[contentId] || undefined;
    if (Component === undefined) {
      onError(`Missing component for ${contentId}`);
      return null;
    }
    const props = contentEntry.fields;
    return /*#__PURE__*/jsx(ErrorBoundary, {
      onError: onError,
      children: /*#__PURE__*/jsx(Component, _objectSpread(_objectSpread({}, props), {}, {
        options: options
      }))
    }, index);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
  });
};
const CMSContent = /*#__PURE__*/memo(({
  content,
  additionalProps
}) => {
  const _useContext = useContext(CMSContext),
    onError = _useContext.onError,
    components = _useContext.components;
  const _useLogger = useLogger(),
    logError = _useLogger.logError;
  const updatedOptions = useMemo(() => _objectSpread(_objectSpread({}, additionalProps), {}, {
    renderNestedComponents
  }), [additionalProps]);
  return renderNestedComponents(Array.isArray(content) ? content : [content], logError || onError, components, updatedOptions
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO Fix this
  );
});
export { CMSContent, renderNestedComponents };
//# sourceMappingURL=CMSContent.js.map
